import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Form } from "reactstrap";
import { Container, Row, Col } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";

import serach_icon from "../../assets/images/icon/search-icon.svg";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import { GetEmailList, DeleteRecords } from "../../services/emailService";
import cross from "../../assets/images/icon/cross.svg";
import { toast } from "react-toastify";
import Avatar from "./emailAvtar";
import EmailBodyPreview from "./emailBodyPreview";
import EmailToFormatter from "./emailToFormetter";
import threedots from "../../assets/images/icon/three-dots.svg";
import Dropdown from "react-bootstrap/Dropdown";

import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

import DOMPurify from "dompurify";

const EmailList = () => {
  const { t } = useTranslation();
  const [emailList, setEmailList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const companyId = localStorage.getItem("subdomainId");

  const fetchEmailList = () => {
    GetEmailList()
      .then(res => {
        if (res?.status === 200) {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);

          setEmailList(responseData?.data);
        }
      })
      .catch(err => {
        console.error("Error fetching email list:", err);
      });
  };

  useEffect(() => {
    fetchEmailList();

    document.title = "NeuroTal - Email List";
  }, []);

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: t(`Email.id`),
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "name",
      text: t(`Email.Sender Name`),
    },
    {
      dataField: "subject",
      text: t(`Email.Subject`),
    },
    {
      dataField: "from",
      text: t(`Email.From`),
      formatter: cell => <EmailToFormatter emails={cell} />,
    },

    {
      dataField: "to",
      text: t(`Email.To`),
      formatter: cell => <EmailToFormatter emails={cell} />,
    },

    /*{
      dataField: "snippet",
      text: t(`Email.Snippet`),
    },*/
    {
      dataField: "body",
      text: t(`Email.Body`),
      formatter: (cell, row) => (
        <EmailBodyPreview
          body={cell}
          row={row}
          handleViewDetails={handleViewDetails}
        />
      ),
    },
    {
      dataField: "date",
      text: t(`Email.Email Date`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "createdAt",
      text: t(`Email.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },

    {
      dataField: "",
      attrs: { "data-th": "Actions" },
      text: t(`Email.Actions`),
      formatter: (cell, row) => {
        let row_id = row?.id;

        return (
          <div className="action-application">
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  aria-label="Open menu"
                >
                  <img src={threedots} alt="Menu" />
                  {/* Optional: Text for accessibility if needed */}
                  {/* <span className="sr-only">Open menu</span> */}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleViewDetails(row)}>
                    {t(`Email.View Details`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];

  const handleViewDetails = email => {
    setSelectedEmail(email);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = emailList.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (emailList.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [emailList.length]);

  const renderCheck = item => {
    const searchableText = (
      item?.department_name +
      item?.description +
      item?.sequence +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1" ? "Active" : "In Active")
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  // console.log('depart',departmentList);return false;

  
  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  if (!checkPermissionStatus("email-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Email.Access Denied`)}</h4>
      </div>
    );
  }

  const formatBody = body => {
    console.log("body", body);
    if (!body || typeof body !== "string") {
      return ""; // Return an empty string if body is undefined or not a string
    }
    return body
      .replace(/(^|\n)\s*>+\s*(\n|$)/g, "\n") // Remove lines that only contain `>`
      .replace(/>+/g, " ") // Replace multiple `>` in normal text with a space
      .replace(/<br\s*\/?>/gi, "\n") // Convert `<br>` tags to `\n`
      .replace(/\n{3,}/g, "\n\n") // Reduce multiple consecutive blank lines to **only one blank line**
      .replace(/\n/g, "<br>") // Convert single `\n` to `<br>`
      .replace(/<\/p>/gi, "<br><br>") // Ensure paragraph breaks remain
      .replace(/(<br\s*\/?>){3,}/gi, "<br><br>");
  };

  console.log("selectedEmail", selectedEmail);
  console.log("emailList", emailList);
  const getFileIcon = filename => {
    const extension = filename.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return "📄"; // PDF Icon
      case "doc":
      case "docx":
        return "📝"; // Word Document Icon
      case "xls":
      case "xlsx":
        return "📊"; // Excel Icon
      case "ppt":
      case "pptx":
        return "📽"; // PowerPoint Icon
      case "txt":
        return "📜"; // Text File Icon
      case "zip":
      case "rar":
        return "🗂"; // Archive Icon
      case "mp3":
      case "wav":
        return "🎵"; // Audio File Icon
      case "mp4":
      case "mov":
      case "avi":
        return "🎥"; // Video File Icon
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "bmp":
      case "svg":
        return "🖼"; // Image File Icon
      default:
        return "📁"; // Default File Icon
    }
  };

  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Email.Email List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          {/* <div className="outerTab-box-wrapper below-vacancy amsterresign  joblist-pages-spaces"> */}
          <div className="outerTab-box-wrapper applicationcard-table">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3">
                <div className="table-data-search pbresop">
                  <div className="total-record">
                    <h5>
                      {t(`Email.Total Records`)}:{" "}
                      <span>{emailList ? emailList.length : 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <div className="serach-bar-top">
                      <form class="form-inline">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder={t(
                            `Department.Search by name, description`
                          )}
                          aria-label="Search"
                          onChange={e => setQuery(e.target.value)}
                        />
                        <span>
                          <img src={serach_icon} alt="search" />
                        </span>
                      </form>
                    </div>

                    <div className="tale-text right-panel mobile-arrow">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right arrow 1" />
                      </button>
                    </div>
                  </div>
                </div>
                {successMessage && (
                  <div class="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}
                {errorMessage && (
                  <div class="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}
                <div className="timeto-hire-card userlist pendiglist-cardss">
                  <div className="table-custome-class range-custome">
                    <>
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={emailList?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                              wrapperClasses="table-wrapper"
                              bodyRef={tbodyRef}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && selectedEmail && (
        <Modal
          size="lg"
          show={modalOpen}
          onHide={() => handleCloseModal()}
          className="edit-modal-card asseentModal screeningtest"
        >
          <Modal.Body>
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>{selectedEmail.subject}</h4>
              </div>
              <div className="filter-content cross" onClick={handleCloseModal}>
                <img src={cross} alt="cross icons" />
              </div>
            </div>

            <div className="bordertops"></div>

            <div className="row mb-3 invite-for-interview">
              <div className="reject-people data justify-content-between">
                <div className="mobile-cards-1">
                  <div className="reject-perople-users">
                    <Avatar name={selectedEmail.name} imageUrl={null} />
                  </div>
                  <div className="sender-details">
                    <div className="sender-info">
                      <strong style={{ color: "#c00509" }}>
                        {selectedEmail.name}
                      </strong>{" "}
                      <span style={{ color: "gray" }}>
                        &lt;{selectedEmail.from}&gt;
                      </span>
                    </div>

                    <div className="to-info">
                      <span
                        style={{
                          color: "#686565",
                          whiteSpace: "preLine",
                          fontSize: "12px",
                        }}
                      >
                        To: {selectedEmail.to?.join(", ")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mobile-cards-2">
                  <span>
                    {" "}
                    {moment(selectedEmail.date).format("ddd M/D/YYYY h:mm A")}
                  </span>
                </div>
              </div>
            </div>

            {/* Email Body */}
            <div className="email-body-section">
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(formatBody(selectedEmail.body)),
                }}
              ></span>
            </div>

            {/* Attachments */}
            {selectedEmail.attachments?.length > 0 && (
              <div className="attachment-div">
                <h6>{selectedEmail.attachments.length} Attachments:</h6>
                <div className="attachment-container">
                  {selectedEmail.attachments.map((attachment, index) => (
                    <div key={index} className="attachment-box">
                      <div className="attachment-icon">
                        {getFileIcon(attachment.filename)}
                      </div>
                      <div className="attachment-name">
                        {attachment.filename}
                      </div>
                      <a
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="attachment-link"
                      >
                        View
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("Close")}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default EmailList;
